import { jsx as r, Fragment as v, jsxs as s } from "@emotion/react/jsx-runtime";
import { Fragment as M, useState as I } from "react";
import { EmptyMessageWrapper as k, StyledSeparator as C, StyledSectionLabel as F, SectionDropdown as $, SectionLabel as D, SectionChevron as E, StyledSelectableCard as T, StyledItemText as W } from "./MenuSections.styled.js";
import { Button as j } from "../../Button/index.js";
import { Expandable as z } from "../../Expandable/index.js";
import { Icon as y } from "../../Icon/index.js";
import { Stack as f } from "../../Stack/index.js";
import { Text as g } from "../../Text/index.js";
import { MenuListVariantEnum as b } from "../../../types/components/menuList.js";
import { FontAwesomeIconsPartooUsed as u } from "../../../types/components/icon.js";
const A = ({
  label: e,
  toggle: n,
  sectionLength: o = 0,
  chevronIcon: a = u.faChevronDown
}) => /* @__PURE__ */ s($, { onClick: n, children: [
  /* @__PURE__ */ r(D, { children: /* @__PURE__ */ r(g, { as: "span", variant: "sort", color: "secondary", children: e }) }),
  /* @__PURE__ */ s(E, { children: [
    /* @__PURE__ */ r(g, { as: "span", variant: "bodySRegular", color: "secondary", children: o }),
    /* @__PURE__ */ r(y, { icon: [a], iconSize: "small", color: "secondary" })
  ] })
] }), O = ({
  options: e,
  isChecked: n,
  onChange: o,
  label: a,
  selectableCardChildren: c,
  itemType: t,
  initialExpanded: l = !0
}) => {
  const [d, i] = I(l), m = (h) => {
    h.stopPropagation(), i((S) => !S);
  }, p = d ? u.faChevronUp : u.faChevronDown;
  return /* @__PURE__ */ s(v, { children: [
    /* @__PURE__ */ r(A, { label: a, toggle: m, sectionLength: e.length, chevronIcon: p }),
    /* @__PURE__ */ r(z, { opened: d, children: /* @__PURE__ */ r(f, { gap: "4px", children: e.map((h) => w(h, n, o, c, t)) }) })
  ] });
}, P = ({
  options: e,
  isChecked: n,
  onChange: o,
  selectableCardChildren: a,
  itemType: c
}) => /* @__PURE__ */ r(v, { children: e.map((t) => w(t, n, o, a, c)) }), R = ({
  options: e,
  isChecked: n,
  onChange: o,
  color: a,
  label: c
}) => {
  const t = e.filter((l) => !n(l));
  return t.length > 0 ? /* @__PURE__ */ s(f, { gap: "0px", children: [
    c && /* @__PURE__ */ r(F, { as: "span", variant: "sort", color: "secondary", children: c }),
    /* @__PURE__ */ r(f, { direction: "row", gap: "8px", style: {
      flexFlow: "wrap",
      padding: "8px"
    }, children: t.map((l) => /* @__PURE__ */ r(j, { shape: "rounded", appearance: "outlined", icon: l?.icon || [u.faAdd], dataTrackId: l.value, onClick: (d) => o(l, d), variant: a, size: "small", children: l.label }, l.value)) })
  ] }) : null;
}, w = (e, n, o, a, c) => /* @__PURE__ */ r(T, { dataTrackId: e.name, name: e.name, checked: n(e), value: e.value, type: c, onChange: (t) => o(e, t), label: /* @__PURE__ */ s(W, { variant: "bodyMMedium", as: "span", children: [
  e.icon && /* @__PURE__ */ r(y, { icon: e.icon }),
  e.label
] }), disabled: e.disabled, children: a }, e.value), X = ({
  sections: e,
  isChecked: n,
  onChange: o,
  selectableCardChildren: a,
  itemType: c,
  emptyMessage: t,
  variant: l
}) => e.length <= 0 ? typeof t == "string" ? /* @__PURE__ */ r(k, { children: /* @__PURE__ */ r(g, { children: t }) }) : t : /* @__PURE__ */ r(v, { children: e.map((d, i) => {
  const {
    label: m,
    options: p,
    color: h,
    initialExpanded: S,
    type: x
  } = d, L = l === b.Chip || x === b.Chip ? /* @__PURE__ */ r(R, { options: p, isChecked: n, onChange: o, color: h || "primary", label: m }, `row-${i}`) : m ? /* @__PURE__ */ r(O, { options: p, isChecked: n, onChange: o, selectableCardChildren: a, itemType: c, label: m, initialExpanded: S }, `withLabel-${i}`) : /* @__PURE__ */ r(P, { options: p, isChecked: n, onChange: o, selectableCardChildren: a, itemType: c }, `withoutLabel-${i}`);
  return /* @__PURE__ */ s(M, { children: [
    i > 0 && /* @__PURE__ */ r(C, {}),
    L
  ] }, `section-${i}`);
}) });
export {
  X as MenuSections
};
